import { on } from "@ngrx/store";
import { DeveloperState } from "../developer.state";
import { TransferQuotesActions } from "./transfer-quotes.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update developer state within PagesStore
// **************************************************************************

function withDeveloper(state: PagesStore, updater: (developer: DeveloperState) => DeveloperState): PagesStore {
    return { ...state, developer: updater(state.developer) };
}

// **************************************************************************
// TRANSFER QUOTES REDUCER (array format for PagesStore)
// **************************************************************************

const transferQuotes = on(TransferQuotesActions.transferQuotes, (state: PagesStore) => withDeveloper(state, developerState => ({
    ...developerState,
    transferQuotes: { ...developerState.transferQuotes, loading: true },
    error: null,
})));

const transferQuotesSuccess = on(TransferQuotesActions.transferQuotesSuccess, (state: PagesStore, { response }) => withDeveloper(state, developerState => ({
    ...developerState,
    transferQuotes: { ...developerState.transferQuotes, result: response, loading: false },
    error: null,
})));

const transferQuotesFailure = on(TransferQuotesActions.transferQuotesFailure, (state: PagesStore, { error }) => withDeveloper(state, developerState => ({
    ...developerState,
    transferQuotes: { ...developerState.transferQuotes, loading: false },
    error,
})));

export const transferQuotesReducer = [
    transferQuotes,
    transferQuotesSuccess,
    transferQuotesFailure,
];
